/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'
import moment from 'jalali-moment'

import '../ShopList/list.scss'

import { Link } from 'react-router-dom'


export default function index(data, shop) {
  const [tables, setTables] = useState([])

  useEffect(() => {
    setTables(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>تاریخ ثبت</th>
            <th>شعبه</th>
            <th>درخواست گارسن</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {tables ? tables.map(item => 
              <tr key={item._id}>
              <td>{item.name}</td>
              <td>{moment(item.createdAt).locale('fa').format('YYYY/MM/DD')}</td>
              <td>{item.branch[0].description}</td>
              <td>{item.serverNeed ? 'دارد' : 'ندارد'}</td>
              <td>
                <Link to={`/im/servers/edit/${item._id}`} id={item._id} style={{ padding: '1em' }}>ویرایش</Link>
                <button>فرستادن</button>
              </td>
            </tr> ) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
